import styled from 'styled-components';

import shouldForwardProp from 'configs/shouldForwardProp';

export const StyledWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const StyledMenu = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 20;
  min-width: 160px;
  padding: ${({ theme }) => theme.spacing.xs}px;
  border-radius: ${({ theme }) => theme.borderRadius.m}px;
  background-color: ${({ theme }) => theme.colors.backgroundSecondary};
  border: 1px solid ${({ theme }) => theme.colors.border};
  box-shadow: ${({ theme }) => theme.shadow.menu};
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const StyledItem = styled.button.withConfig({ shouldForwardProp })<{ danger?: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.s}px ${({ theme }) => theme.spacing.m}px;
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.s}px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSizes.s}px;
  color: ${({ theme, danger }) => (danger ? theme.colors.danger : theme.colors.textPrimary)};

  &:hover {
    background-color: ${({ theme }) => theme.colors.backgroundTertiary};
  }
`;
